var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"template-container",staticClass:"assessment-report-template-container"},[_c('div',{attrs:{"data-report-version":_vm.data.version || 1.0},domProps:{"innerHTML":_vm._s(_vm.renderTemplate())}}),_c('div',{staticClass:"reportVersion"},[_vm._v("v"+_vm._s(_vm.data.version || "n/a"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }